<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">

            <EmpresaList :processo="processo" :prefix="updatedPrefix" @onDblClickEmpresaSelect="empresaSelect"
                :empresas="empresas" />
        </b-modal>

        <lg-form-input-finder v-if='!modalOnly' :classFormGroup='classFormGroupBind' :disabled="disabled"
            :value="computedValue" @input="updateValue" fieldDescription="razaoSocial" :label="label"
            invalidFeedback="Empresa deve ser informada!" description="" @handleClean="empresaSelect" :error="error"
            :cols="cols">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import EmpresaList from "@/modules/cadastros/empresa/EmpresaList.vue"

export default {
    name: "LgFinderPageEmpresa",
    components: { LgFormInputFinder, EmpresaList },
    props: {
        id: {
            type:String,
            default:"empresaFinder"
        },
        processo: {
            type: Number,
            default: null
        },

        prefix: {
            type: Array,
            default: () => []
        },
        modalOnly: {
            type: Boolean,
            default: false
        },
        classFormGroupBind: {
            type: String,
            default: "",
        },
        value: {
            type: [Object, String],
            default: () => ({})
        },
        cols: String,
        label: {
            type: String,
            default: 'Empresa:'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: Object,
            default: null,
        },
        empresas: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            internalValue: this.value || {},
        };
    },
    watch: {
        value(newValue) {
            if (typeof newValue === 'object') {
                this.internalValue = newValue;
            } else {
                this.internalValue = {};
            }
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue;
            },
            set(newValue) {
                this.internalValue = newValue;
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Empresa"].filter(value => value != "");
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        updateValue(newValue) {
            this.computedValue = newValue;
            this.$emit("input", newValue);
        },
        empresaSelect(item) {
            this.computedValue = item;
            this.$emit("input", item);
            this.$bvModal.hide(this.id);
        },
    },
};
</script>
